"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHighway = void 0;
var Highway_1 = require("./src/Highway");
function createHighway(apiKey, options) {
    return new Highway_1.Highway(apiKey, options || {});
}
exports.createHighway = createHighway;
//# sourceMappingURL=index.js.map